import React from "react";

import { faTimes } from "@fortawesome/pro-solid-svg-icons";

import { Button } from "src/base-components/Button";
import { WorkspaceSimpleRoleType } from "src/clients/taktile-api";
import {
  useRoleOverride,
  useRoleOverrideActions,
} from "src/hooks/useCapabilities/RoleOverrideStore";
import { useIsTaktileOrgUser } from "src/hooks/useIsTaktileOrgUser";

const getRoleDisplayName = (
  role: WorkspaceSimpleRoleType,
  isFWD: boolean,
): string => {
  if (isFWD) {
    return "FWD/Admin";
  }
  switch (role) {
    case WorkspaceSimpleRoleType.ADMIN:
      return "Admin";
    case WorkspaceSimpleRoleType.EDITOR:
      return "Editor";
    case WorkspaceSimpleRoleType.REVIEWER:
      return "Reviewer";
    case WorkspaceSimpleRoleType.VIEWER:
      return "Viewer";
    default:
      return "Unknown";
  }
};

export const RoleOverrideIndicator: React.FC = () => {
  const isTaktileUser = useIsTaktileOrgUser();
  const { overrideWorkspaceRole, overrideFWDOrAdmin } = useRoleOverride();
  const { clearOverrideRole } = useRoleOverrideActions();

  // Only show for Taktile users with active override
  if (!isTaktileUser || overrideWorkspaceRole === null) {
    return null;
  }

  const roleDisplayName = getRoleDisplayName(
    overrideWorkspaceRole,
    overrideFWDOrAdmin,
  );

  return (
    <div className="fixed bottom-3 left-1/2 z-50 -translate-x-1/2 transform">
      <Button
        dataLoc="role-override-indicator"
        iconLeft={faTimes}
        variant="warning"
        onClick={clearOverrideRole}
      >
        Remove Role Override: {roleDisplayName}
      </Button>
    </div>
  );
};
